// Vendor
import { Injectable, LOCALE_ID, Inject } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { tap } from "rxjs/operators";

// App
import { OrderStorageService } from "../order-storage/order-storage.service";
import { OrderStorageServiceAbstract } from "../order-storage/storage-service";
import { Order } from "./order";
import { Invoice } from "./invoice";

// Create our number formatter.
const formatter = new Intl.NumberFormat("nl-NL", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
});

@Injectable({
    providedIn: "root",
})
export class OrderService {
    public invoice: Invoice = {} as Invoice;
    public quote: Invoice = {} as Invoice;
    public total = 0.0;
    public quoteTotal = 0.0;

    public useEphemeralStorage = true;
    public storage: OrderStorageServiceAbstract;
    public order_: Order;

    public get order() {
        return this.storage.order;
    }

    public set order(order: Order) {
        this.storage.order = order;
    }

    /**
     * @deprecated
     */
    public commitOrderToStorage() {
        return void 0;
    }

    public saveValues(values: Order) {
        const updatedOrder = { ...this.order, ...values };
        this.order = updatedOrder;
    }

    constructor(
        private http: HttpClient,
        private orderStorageService: OrderStorageService,

        @Inject(LOCALE_ID)
        private readonly locale: "nl" | "fr",
    ) {
        switch (true) {
            case this.orderStorageService.local.isEnabled: {
                this.storage = orderStorageService.local;
                this.useEphemeralStorage = false;
                break;
            }
            case this.orderStorageService.session.isEnabled: {
                this.storage = orderStorageService.session;
                this.useEphemeralStorage = false;
                break;
            }
            default: {
                this.storage = orderStorageService.memory;
            }
        }

        this.order = this.order || new Order();
        this.order.locale = this.locale;
    }

    public updateTotal() {
        this.getQuote().subscribe();
    }

    public get totalCurrency(): string {
        return formatter.format(this.total);
    }

    public get totalUnits(): string {
        return this.totalCurrency.split(",")[0];
    }

    public get totalFractions(): string {
        return this.totalCurrency.split(",")[1];
    }

    public saveQuote(quote: Invoice): void {
        this.quote = quote;
        this.total = quote.total;
    }

    public getQuote() {
        return this.http
            .post<Invoice>("/api/v1/order/quote", this.order)
            .pipe(tap(quote => this.saveQuote(quote)));
    }

    public sendIt() {
        return this.http.post("/api/v1/order/send", this.order);
    }
}
